'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'right-from-bracket';
var width = 512;
var height = 512;
var aliases = ["sign-out-alt"];
var unicode = 'f2f5';
var svgPathData = 'M505 273l0 0c9.4-9.4 9.4-24.6 0-33.9l0 0-144-144c-6.9-6.9-17.2-8.9-26.2-5.2S320 102.3 320 112l0 80-112 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l112 0 0 80c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L505 273zM352 131.3L476.7 256 352 380.7 352 304c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l128 0c8.8 0 16-7.2 16-16l0-76.7zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-35.3 0-64-28.7-64-64l0-256c0-35.3 28.7-64 64-64l80 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRightFromBracket = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;